import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  DEFAULT_PAGE,
  buildPath,
  readPagination,
  writePagination,
} from './listPagination';

export interface UseListPageUrlSyncOptions {
  setFilter: (filter: Record<string, unknown>) => void;
  setPrevSearch: (search: string) => void;
  prevSearch: string;
  scrollToTop: () => void;
  getProperFilterValues: (fields: string[]) => Record<string, unknown>;
  filterFields: string[];
  onSync: (params: {
    filterParams: Record<string, unknown>;
    page: number;
    page_size: number;
    currentSearch: string;
  }) => void;
}

export function useListPageUrlSync({
  setFilter,
  setPrevSearch,
  prevSearch,
  scrollToTop,
  getProperFilterValues,
  filterFields,
  onSync,
}: UseListPageUrlSyncOptions) {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const { page, pageSize } = readPagination(urlParams);

    const currentSearch = urlParams.get('search') || '';
    const searchChanged = prevSearch !== currentSearch;

    if (searchChanged && page !== DEFAULT_PAGE) {
      writePagination(urlParams, { page: DEFAULT_PAGE, pageSize });
      navigate(buildPath(location.pathname, urlParams), { replace: true });
      setPrevSearch(currentSearch);
      return;
    }

    const queryParams = getProperFilterValues(filterFields);
    const filterParams = { ...queryParams };
    delete filterParams.page;
    delete filterParams.page_size;
    delete filterParams.search;

    setFilter(filterParams);

    onSync({ filterParams, page, page_size: pageSize, currentSearch });
    setPrevSearch(currentSearch);
    scrollToTop();
  }, [location.search]);
}
